import React, { useMemo } from 'react'
import GrammatechCodeSentryCredentialForm from './GrammatechCodeSentryCredentialForm';
import GrammatechCodeSentryMappingForm from './GrammatechCodeSentryMappingForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function GrammatechCodeSentryConfigListing(props) {

    const extraColumns = useMemo(() => [
        {
            dataIndex: "applicationName",
            title: 'Application',
            width: 120
        }
    ],[]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={GrammatechCodeSentryMappingForm}
            CredentialsForm={GrammatechCodeSentryCredentialForm}
            extraColumns={extraColumns}
        />
    )
}